import { useUpdateEntityApi } from "@/common/api/updateEntityApi";
import type { DashboardResponse } from "./common/dashboardResponse";
import { useDashboardStore } from "../stores/dashboardStore";
import type { DashboardComponetRequest } from "./common/dashboardComponentRequest";


export interface UpdateDashboard {
  name?: string;
  components: DashboardComponetRequest[];
}

export interface UpdateProductResponse {
  ok: true;
  dashboard: DashboardResponse;
}

export function useUpdateDashboardApi() {

  const store = useDashboardStore();

  return useUpdateEntityApi<UpdateDashboard, UpdateProductResponse>({
    url: 'dashboard',
    translate: (t) => t.dashboard.actions.update,
    async processOk(response) {
      const json = await response.json() as DashboardResponse;
      store.add(json);
      return {
        ok: true,
        dashboard: json
      };
    },
  })
}
